import * as React from 'react';
import { useSelector } from 'react-redux';

import { EMediaType, TMedia } from 'shared/components/NewbuildingGallery';
import { NewbuildingBrokerGalleryBannerContainer } from 'shared/containers/NewbuildingBrokerGalleryBanner';
import { NewbuildingPushToCallBannerContainer } from 'shared/containers/NewbuildingPushToCallBanner';
import { isNewbuildingSelector } from 'shared/selectors';
import { getOffer } from 'shared/selectors/newObject';
import { selectOfferBookingEnabled } from 'shared/selectors/newbuildingBrokerOfferBooking';
import { isLeadFactory } from 'shared/utils/agent';

export const useMiddleBanner = (thumbnailSrc: string): TMedia | null => {
  const isNewbuilding = useSelector(isNewbuildingSelector);
  const offer = useSelector(getOffer);
  const offerBookingEnabled = useSelector(selectOfferBookingEnabled);

  return React.useMemo<TMedia | null>(() => {
    const isFromDeveloper = Boolean(offer.newbuilding?.isFromDeveloper);
    const isAvailable = isFromDeveloper && !isLeadFactory(offer);

    if (!isNewbuilding || !isAvailable) {
      return null;
    }

    const component = offerBookingEnabled ? (
      <NewbuildingBrokerGalleryBannerContainer />
    ) : (
      <NewbuildingPushToCallBannerContainer />
    );

    return {
      type: EMediaType.Component,
      component,
      thumbnailSrc,
    };
  }, [isNewbuilding, thumbnailSrc, offer, offerBookingEnabled]);
};
